import { IconPlus } from "@tabler/icons-react";
import { createPortal } from "react-dom";

interface AddButtonProps {
  onClick: () => void;
  zIndex?: number;
  noPortal?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({ onClick, zIndex = 150, noPortal = false }) => {
  const button = (
    <button
      className="fixed bottom-[10px] right-[10px] w-[60px] h-[60px] rounded-full shadow-gray shadow-lg text-5xl flex justify-center items-center bg-green cursor-pointer text-white"
      style={{ zIndex }}
      type="button"
      aria-label="New discussion"
      data-testid="add-button"
      onClick={onClick}
    >
      <IconPlus strokeWidth={4} />
    </button>
  );

  return noPortal ? button : createPortal(button, document.body);
};

export default AddButton;
